import { IExportBehavior, ILayerBehavior, LayerType } from '@/version-types';
import { createFontBehaviors } from './behaviors/font';
import { createOperationBehaviors } from './behaviors/operation';
import { createRendererBehaviors } from './behaviors/renderer';
import { createSaveBehaviors } from './behaviors/save';

const getBehavior = (frameworkIdentity: string) => {
    const rendererBehaviors = createRendererBehaviors(frameworkIdentity);
    const operationBehaviors = createOperationBehaviors(frameworkIdentity);
    const fontBehaviors = createFontBehaviors(frameworkIdentity);
    const saveBehaviors = createSaveBehaviors(frameworkIdentity);

    const layerBehavior: ILayerBehavior = {
        ...rendererBehaviors,
        ...operationBehaviors,
        ...fontBehaviors,
        ...saveBehaviors,
        checkDisableFlip() {
            return true;
        },
    };

    return layerBehavior;
};

export default {
    layerType: LayerType.CHART,
    getBehavior,
} as IExportBehavior;
